import React from "react";
import { BackpackIcon, HandHeartIcon, MessagesSquareIcon, MoonIcon, SproutIcon, WavesIcon, BoxIcon } from "lucide-react";
import { images, situations } from "../data/content";
import { SectionHeading } from "./SectionHeading";
const icons: Record<string, BoxIcon> = {
  dropoff: BackpackIcon,
  bedtime: MoonIcon,
  whatif: MessagesSquareIcon,
  separation: HandHeartIcon,
  new: SproutIcon,
  feelings: WavesIcon
};
export function ToolkitIntro() {
  return <section className="bg-cream py-14 lg:py-24" data-id="element-190" data-mp="zjpjfrq34wl7">
      <div className="mx-auto grid max-w-content items-center gap-8 px-5 sm:px-8 lg:grid-cols-[minmax(0,1.15fr)_minmax(0,0.85fr)] lg:gap-14" data-id="element-191" data-mp="umgyjjdjyeg9">
        <div className="lg:order-2" data-id="element-192" data-mp="qn89grtgj4r1">
          <SectionHeading title="Everything You Need When Worry Shows Up" className="lg:mx-0 lg:text-left" data-id="element-193" data-mp="lmk7jb3ox3i1" />
          <p className="mt-3 text-center text-[16px] font-semibold uppercase tracking-[0.12em] text-terra-deep lg:text-left" data-id="element-194" data-mp="3bbmjd1ozbcr1">
            6 Practical Volumes + 5 Ready-to-Use Bonuses
          </p>
        </div>

        <img src={images.bundle} alt="The complete Worry-to-Brave Toolkit: six volumes and five bonuses" loading="lazy" className="-mx-2 w-[calc(100%+1rem)] max-w-[640px] sm:mx-auto sm:w-full lg:order-1 lg:row-span-2" data-id="element-195" data-mp="3oyg3r81z2frv" />

        <div className="lg:order-3" data-id="element-196" data-mp="3fw6t8i6pemeh">
          <ul className="grid grid-cols-2 gap-2.5 sm:grid-cols-3 lg:grid-cols-2" data-id="element-197" data-mp="3kvrs6slviur7">
            {situations.map(s => {
            const Icon = icons[s.id];
            return <li key={s.id} className="flex items-center gap-2.5 rounded-xl bg-paper px-3 py-3 shadow-card" data-id="element-198" data-mp="365c49622p8pc">
                  <Icon className="h-4 w-4 shrink-0 text-dusty-deep" aria-hidden="true" data-id="element-199" data-mp="3azosdtehv87f" />
                  <span className="text-[14px] font-medium leading-tight text-ink" data-id="element-200" data-mp="2x81whuogs1p6">{s.label}</span>
                </li>;
          })}
          </ul>
          <p className="mt-6 text-[17px] leading-relaxed text-ink-soft" data-id="element-201" data-mp="2n8axbfoykyir">
            No complicated techniques to memorize. Just practical guidance, words and tools to come back to when you need them.
          </p>
          <p className="mt-4 font-display text-[21px] italic leading-snug text-ink" data-id="element-202" data-mp="xr5njyz98fme">
            The goal isn’t more information. It’s feeling more prepared when the moment actually happens.
          </p>
        </div>
      </div>
    </section>;
}